import { create } from 'zustand';
import {
  fetchStatementList,
  FetchStatementListRequest,
  StatementType,
  updateStatementStatus,
  UpdateStatementStatusRequest,
} from './api/statements-api';
import { useAlertStore } from './use-alert-store';

interface Store {
  list?: StatementType[];
  isLoading?: boolean;
  fetchStatementList: (request: Partial<FetchStatementListRequest>) => Promise<void>;
  updateStatementStatus: (request: UpdateStatementStatusRequest) => Promise<void>;
}

export const useStatementsStore = create<Store>((set) => ({
  fetchStatementList: async (request) => {
    set({ isLoading: true });
    try {
      const resp = await fetchStatementList(request);
      set({ list: resp });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось получить заявления', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },

  updateStatementStatus: async (request) => {
    set({ isLoading: true });
    try {
      await updateStatementStatus(request);
      set((state) => ({
        list: state.list?.map((item) =>
          item.id === request.id ? { ...item, ...request } : item,
        ),
      }));
      useAlertStore
        .getState()
        .add({ label: 'Статус заявления успешно обновлен', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось обновить статус заявления', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
}));
